import { Box, Container, Typography, Link as MuiLink } from "@mui/material";
import Logo from "../Logo";
import React from "react";
import { NAV_LINKS, BlackLogo } from "../../consts";
import { Link as RouterLink } from "react-router-dom";
export default function SiteFooter() {
    return (React.createElement(Box, { component: "footer", sx: {
            mt: "auto",
        }, bgcolor: "background.paper" },
        React.createElement(Container, { maxWidth: "lg", sx: {
                py: {
                    xs: 3.5,
                    sm: 4,
                    md: 4,
                },
            } },
            React.createElement(Box, { sx: {
                    display: "flex",
                    flexDirection: {
                        xs: "column",
                        md: "row",
                    },
                    alignItems: {
                        xs: "center",
                        md: "center",
                    },
                    justifyContent: "space-between",
                    gap: {
                        xs: 2.5,
                        md: 4,
                    },
                } },
                React.createElement(Box, { sx: {
                        height: {
                            xs: 90,
                            md: 110,
                        },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    } },
                    React.createElement(Logo, { fileName: BlackLogo, sx: {
                            width: {
                                xs: 120,
                                sm: 150,
                                md: 200,
                            },
                            maxHeight: "75%",
                            height: "auto",
                        } })),
                React.createElement(Box, { sx: {
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        gap: {
                            xs: 2.5,
                            sm: 3.5,
                            md: 4,
                        },
                    } }, NAV_LINKS.map((link) => {
                    return (React.createElement(MuiLink, { component: RouterLink, key: link.to, to: `/${link.to}`, sx: {
                            py: 1.75,
                            fontFamily: "'Jost', sans-serif",
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            letterSpacing: "0.14em",
                            textTransform: "uppercase",
                            textDecoration: "none",
                            color: "primary.main.dark",
                            borderBottom: "2px solid",
                            borderColor: "divider",
                        } }, link.label));
                }))),
            React.createElement(Box, { sx: {
                    width: "100%",
                    height: "1px",
                    my: {
                        xs: 2.5,
                        md: 3,
                    },
                } }),
            React.createElement(Box, { sx: {
                    display: "flex",
                    flexDirection: {
                        xs: "column",
                        sm: "row",
                    },
                    justifyContent: "space-between",
                    alignItems: {
                        xs: "center",
                        sm: "center",
                    },
                    textAlign: {
                        xs: "center",
                        sm: "left",
                    },
                    gap: 1,
                } },
                React.createElement(Typography, { sx: {
                        fontSize: 10,
                        letterSpacing: "0.04em",
                    } },
                    "\u00A9 ",
                    new Date().getFullYear(),
                    " Kylie Jean Photography"),
                React.createElement(Typography, { sx: {
                        fontSize: 10,
                        letterSpacing: "0.04em",
                    } }, "Capturing moments worth remembering.")))));
}
